function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 9.713L.015 0h23.97L12 9.713zm0 2.574L0 2.562V18h24V2.562l-12 9.725z",
  fill: "#000"
});

function SvgEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyNCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDkuNzEzTDAuMDE1IDBIMjMuOTg1TDEyIDkuNzEzWk0xMiAxMi4yODdMMCAyLjU2MlYxOEgyNFYyLjU2MkwxMiAxMi4yODdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";
export { SvgEmailIcon as ReactComponent };